import { render, staticRenderFns } from "./RequisitionForm.vue?vue&type=template&id=6f34b13a&scoped=true&"
import script from "./RequisitionForm.vue?vue&type=script&lang=ts&"
export * from "./RequisitionForm.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionForm.vue?vue&type=style&index=0&id=6f34b13a&lang=scss&scoped=true&"
import style1 from "./RequisitionForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f34b13a",
  null
  
)

export default component.exports